// Context لجلب العجلات والمواسم من الـAPI مرة واحدة وإعادة استخدامها.
import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { publicApi } from "../lib/api";

const EventsContext = createContext(null);

export const EventsProvider = ({ children }) => {
  const [events, setEvents] = useState([]);
  const [seasons, setSeasons] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const refresh = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const [ev, sn] = await Promise.all([
        publicApi.get("/events"),
        publicApi.get("/seasons"),
      ]);
      setEvents(ev.data?.items || []);
      setSeasons(sn.data?.items || []);
    } catch (err) {
      setError(err?.message || "فشل تحميل البيانات.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const value = useMemo(
    () => ({ events, seasons, loading, error, refresh }),
    [events, seasons, loading, error, refresh]
  );

  return <EventsContext.Provider value={value}>{children}</EventsContext.Provider>;
};

export const useEventsData = () => {
  const ctx = useContext(EventsContext);
  if (!ctx) throw new Error("useEventsData must be used within EventsProvider");
  return ctx;
};
